import { store } from 'store';

export const useStores = () => {
  return store;
};
